<template>
  <div id="ticketEdit">
    <app-menu></app-menu>
    <div class="col-lg-8 offset-lg-2">
      <h3 class="text-center pb-lg-4">{{ "Admin.menu.tickets" | staticTranslation }}</h3>
      <div class="form-group">
        <label>{{ "TicketAdmin.title" | staticTranslation }}</label>
        <input v-model="ticket.title" class="form-control" type="text">
      </div>
      <div class="form-group">
        <label>{{ "TicketAdmin.place" | staticTranslation }}</label>
        <input v-model="ticket.place" class="form-control" type="text">
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="form-group">
            <label>{{ "TicketAdmin.date" | staticTranslation }}</label>
            <input v-model="ticket.dateLabel" class="form-control" type="text">
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label>{{ "TicketAdmin.time" | staticTranslation }}</label>
            <input v-model="ticket.timeLabel" class="form-control" type="text">
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>{{ "TicketAdmin.link" | staticTranslation }}</label>
        <input v-model="ticket.ticketLink" class="form-control" type="text">
      </div>
      <div class="form-check form-switch pt-lg-4 text-center">
        <input id="visible" v-model="ticket.visible" class="form-check-input" type="checkbox">
        <label class="form-check-label" for="visible">{{ "TicketAdmin.visible" | staticTranslation }}</label>
      </div>
      <div class="text-center pt-lg-4">
        <send-button
            :send="save"
            :text="'TicketAdmin.save' | staticTranslation"
            :response="error"
        />
      </div>
    </div>
    <error-modal :message="error"/>
  </div>
</template>

<script>
import axios from "@/api/axiom-instance";
import ErrorModal from "@/components/admin/ErrorModal";
import AdminMenu from "@/components/admin/AdminMenu";
import SendButton from "@/components/admin/SendButton";

export default {
  name: "TicketEdit",
  components: {
    'app-menu': AdminMenu,
    'error-modal': ErrorModal,
    'send-button': SendButton
  },
  data() {
    return {
      ticket: {
        title: "",
        place: "",
        dateLabel: "",
        timeLabel: "",
        ticketLink: "",
        visible: true
      },
      error: null
    }
  },
  created() {
    if (this.$route.params.id != null) {
      this.load(this.$route.params.id)
    }
  },
  methods: {
    save: function () {
      axios.post("/ticket", this.ticket).then(() => {
        this.$router.push({path: "/admin/ticket"})
      }).catch(error => this.error = error)
    },
    load: function (id) {
      axios.get("/ticket", {params: {id: id}})
          .then((success) => {
            this.ticket = success.data
          }).catch(error => this.error = error)
    }
  }
}
</script>

<style scoped>
#ticketEdit {
  min-height: 100vh;
  padding-bottom: 4em;
  overflow: hidden;
}
</style>
